import React from 'react';
import { styled } from "../../stitches.config"
import { h4Strong, bodyStrong } from "../commonStyles/Fonts";
import PhotoOnLeft from "./PhotoOnLeft";

import { SimilarArticlesType } from "../../stores/ArticleStore"

type SeeAlsoArticlesProps = {
    articles: SimilarArticlesType[];
    boxSize?: "small" | "big";
    isPodcast?: boolean;
    isDarkMode?: boolean;
}

const SeeAlsoArticles: React.FC<SeeAlsoArticlesProps> = ({
    articles,
    boxSize = "big",
    isPodcast, isDarkMode,
    ...props
}) => {
    return (
        <StyledSeeAlsoArticles isDarkMode={!!isDarkMode} isPodcast={!!isPodcast}>
            <Header>
                {boxSize === "small" ? (<p className={bodyStrong()}>Zobacz również</p>) : (<p className={h4Strong()}>Zobacz także</p>)}
                <BlackLine></BlackLine>
            </Header>
            {boxSize === "small" ?
                (<SmallWrapper>
                    {articles.map((article, i) =>
                        <PhotoOnLeft
                            key={"similar_articles__" + i}
                            article={article}
                            boxSize="xxs"
                            dataAnalyticsName={"right-column-zr-" + i} />
                    )}
                </SmallWrapper>)
                :
                (<Wrapper>
                    {articles.map((article, i) =>
                        <PhotoOnLeft
                            key={"similar_articles__" + i}
                            article={article}
                            boxSize="xs"
                            dataAnalyticsName={"left-column-zr-" + i} />

                    )}
                </Wrapper>)}
            <BlackLine></BlackLine>
        </StyledSeeAlsoArticles>
    );
};

const StyledSeeAlsoArticles = styled('div', {
    margin: "20px 0",
    background: "$grayscale10",
    position: "relative",
    zIndex: 10,
    variants: {
        isPodcast: {
            true: {
                background: "#fff"
            },
            false: {}
        },
        isDarkMode: {
            true: {
                fontSize: '2px'
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            isPodcast: true,
            isDarkMode: true,
            css: {
                background: "$grayscale10",
            }
        }
    ]
})

const Wrapper = styled('div', {
    padding: "40px 0 2px 0",
    display: "flex",
    flexWrap: "wrap",
    "@bp4": {
        justifyContent: "space-between",
        padding: "40px 0 0 0",
    },
    "& .photo-on-left": {
        width: "100%",
        marginBottom: "24px",
        "@bp4": {
            width: "calc(50% - 12px)",
            marginBottom: "40px",
        }
    },
    "& a": {
        flexShrink: 0,
    }
})

const SmallWrapper = styled('div', {
    padding: "40px 0 16px 0",
    "@bp4": {
        padding: "32px 0 8px 0",
    },
    "& .photo-on-left": {
        marginBottom: "24px !important",
    },
})

const Header = styled('div', {
    display: "flex",
    alignItems: "center",
    "& p": {
        flexShrink: 0,
        margin: "0 16px 0 0",
        color: '$grayscale100',
    }
})

const BlackLine = styled('div', {
    borderTop: "2px solid $grayscale100",
    width: "100%",
})

export default SeeAlsoArticles